import React from 'react';
import PropTypes from 'prop-types';

import { cn } from 'helpers/classnames';
import MartyLink from 'components/common/MartyLink';
import useMartyContext from 'hooks/useMartyContext';

import styles from 'styles/components/account/backNav.scss';

const BackNav = props => {
  const { to, className } = props;
  const { testId } = useMartyContext();
  return (
    <div className={styles.container}>
      <MartyLink to={to} data-test-id={testId('backNav')} className={cn(styles.backNav, 'zappos:body-s-bold', className)} {...props} />
    </div>
  );
};

BackNav.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default BackNav;
